import { render, staticRenderFns } from "./tcrgList.vue?vue&type=template&id=7da65faa&scoped=true&"
import script from "./tcrgList.vue?vue&type=script&lang=js&"
export * from "./tcrgList.vue?vue&type=script&lang=js&"
import style0 from "./tcrgList.vue?vue&type=style&index=0&id=7da65faa&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7da65faa",
  null
  
)

export default component.exports